import "@/App.css";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import { HeroSection } from "./components/sections/HeroSection";
import { SolutionSection } from "./components/sections/SolutionSection";
import { FeaturesSection } from "./components/sections/FeaturesSection";
import { AgroScanSection } from "./components/sections/AgroScanSection";
import { BenefitsSection } from "./components/sections/BenefitsSection";
import { BlogSection } from "./components/sections/BlogSection";
import { AboutSection } from "./components/sections/AboutSection";
import { ContactSection } from "./components/sections/ContactSection";

function App() {
  return (
    <div className="App min-h-screen bg-[#FBF5EA]">
      <Navbar />
      <main>
        <HeroSection />
        <SolutionSection />
        <FeaturesSection />
        <AgroScanSection />
        <BenefitsSection />
        <BlogSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
